import { catchAxiosError } from 'utilities/axios';
import axiosInstance from 'api-services/api-client';

export const createChatBot = async (payload) => {
  return catchAxiosError(
    axiosInstance
      .post('/admin/create-chatbot', payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const createSpreadsheetChatBot = async (payload) => {
  return catchAxiosError(
    axiosInstance
      .post('/admin/create-spreadsheet-chatbot', payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const uploadFile = async (payload) => {
  return catchAxiosError(
    axiosInstance
      .post('admin/upload-data-from-file', payload, {
        headers: {
          'Content-Type': 'multipart/form-data', // Important for file uploads.
        },
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const uploadSpreadsheet = async (payload) => {
  return catchAxiosError(
    axiosInstance
      .post('admin/upload-data-from-spreadsheet', payload, {
        headers: {
          'Content-Type': 'multipart/form-data', // Important for file uploads.
        },
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};



export const updateFile = async (id, payload) => {
  return catchAxiosError(
    axiosInstance
      .put(`admin/update_bot_source/${id}`, payload, {
        headers: {
          'Content-Type': 'application/json', // Important for file uploads.
        },
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const updateSpreadsheet = async (id, payload) => {
  return catchAxiosError(
    axiosInstance
      .put(`admin/update_spreadsheet/${id}`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data', // Important for file uploads.
        },
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const getSourceDetails = async (id) => {
  return catchAxiosError(
    axiosInstance
      .get(`admin/chatbot-source-details/${id}`, {
        headers: {
          'Content-Type': 'multipart/form-data', // Important for file uploads.
        },
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const createWebsiteChatbot = async (payload) => {
  return catchAxiosError(
    axiosInstance
      .post('/admin/create-website-chatbot', payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const updateWebsiteChatbot = async (id, payload) => {
  return catchAxiosError(
    axiosInstance
      .put(`/admin/update-website-chatbot/${id}`, payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};
